import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { toast } from 'react-toastify';
import { makeApiRequests } from '../../helpers/api';
import Loader from '../Loader';

const getLocalResponse = endpoint => {
  const localChoices = localStorage.getItem(endpoint);
  if (localChoices) {
    try {
      return JSON.parse(localChoices);
    } catch (e) {}
  }
  return null;
};
const CachedResponse = ({ render, listEndpoint, forceFreshData, triggerRefetch, onRefetchComplete }) => {
  const [response, setResponse] = useState(null);
  const [responseLoading, setResponseLoading] = useState(true);
  const [unauthorized, setUnauthorized] = useState(false);

  const getResponse = () => {
    const localResponse = getLocalResponse(listEndpoint);
    if (!forceFreshData && localResponse) {
      setResponse(localResponse);
      setResponseLoading(false);
    }

    fetchRemoteResponse(forceFreshData || !localResponse);
  };

  const fetchRemoteResponse = async passResponseToParent => {
    const { response: remote, error } = await makeApiRequests({
      endpoint: `/${listEndpoint}/list`,
      authSilent: true
    });
    if (error) {
      toast.error(error);
      setResponseLoading(false);
      return;
    }
    if (remote == null) {
      setUnauthorized(true);
      setResponseLoading(false);
      if (passResponseToParent) {
        setResponse(null);
      }
      return;
    }

    if (passResponseToParent) {
      setResponse(remote);
      setResponseLoading(false);
    }

    localStorage.setItem(listEndpoint, JSON.stringify(remote));
  };

  useEffect(() => {
    getResponse();
  }, []);

  useEffect(() => {
    const fetchRemoteResponseTrigger = async () => {
      if (triggerRefetch) {
        await fetchRemoteResponse(true);
        if (onRefetchComplete) {
          onRefetchComplete();
        }
      }
    };
    fetchRemoteResponseTrigger();
  }, [triggerRefetch]);

  if (unauthorized) {
    const returnTo = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    const redirect = returnTo && returnTo !== '/' ? `?redirect=${encodeURIComponent(returnTo)}` : '';
    return <Redirect to={`/login${redirect}`} />;
  }

  if (responseLoading) return <Loader />;

  return response ? render(response) : '';
};

export default CachedResponse;
